<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　

    <div class="mypagebox">
      <div class="leftbox">
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMyinfo()"><p>我的信息</p></a>
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMyorder()"
            ><p>我的订单</p></a
          >
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMytie()"><p>百万铁人</p></a>
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMycourse()"
            ><p>我的课程</p></a
          >
        </div>
        <div class="mypageboxitem">
          <a href="javascript:void(0)" @click="ShowMyrace()"><p>我的赛事</p></a>
        </div>
      </div>
      <div class="rightbox">
        <div class="rightsubbox" v-if="showtype == 1">
          <p>我的信息</p>
        </div>
        <div class="rightsubbox" v-if="showtype == 2">
          <p>我的订单</p>
        </div>

        <div class="rightsubbox" v-if="showtype == 3">
          <p>百万铁人</p>
        </div>
        <div class="rightsubbox" v-if="showtype == 4">
          <p>我的课程</p>
        </div>
        <div class="rightsubbox" v-if="showtype == 5">
          <p>我的赛事</p>
        </div>
      </div>
    </div>

    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios

export default {
  name: "Myselfpage",
  data() {
    return {
      showtype: 1,
      msg: "",
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {},
  methods: {
    ShowMyinfo: function () {
      this.showtype = 1;
    },
    ShowMyorder: function () {
      this.showtype = 2;
    },
    ShowMytie: function () {
      this.showtype = 3;
    },
    ShowMycourse: function () {
      this.showtype = 4;
    },
    ShowMyrace: function () {
      this.showtype = 5;
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.mypagebox {
  width: 100vw;
  height: auto;
  position: relative;
  background-color: #181818;
}
.leftbox {
  position: relative;
  width: 10vw;
  height: 100%;
  left: 5vw;
  background-color: #000;
  padding-top: 4vw;
}
.leftbox .mypageboxitem {
  width: 100%;
  height: 4vw;
  /* background-color: #111; */
}
.leftbox .mypageboxitem p {
  font-size: 1.5vw;
  color: #fff;
  line-height: 4vw;
  width: 100%;
  text-align: center;
}
.rightbox {
  position: absolute;
  width: 80vw;
  height: 100%;
  left: 15vw;
  top: 0;
  /* background-color: #000  ; */
}
.rightbox .mypageboxitem {
  width: 100%;
  height: 4vw;
  background-color: #111;
}
.rightbox .rightsubbox p {
  font-size: 1.5vw;
  color: #fff;
  line-height: 4vw;
  width: 100%;
  text-align: center;
}


</style>



// WEBPACK FOOTER //
// src/components/Myselfpage.vue